import { RootState } from '@app/redux/root-reducer';
export const selectAddReviewState = (store: RootState) => store.reviewsReducer.addReview;
export const selectReviewState = (store: RootState) => store.reviewsReducer.reviews;
export const selectSearchUserState = (store: RootState) => store.reviewsReducer.searchUser;
export const selectUpdateReviewState = (store: RootState) => store.reviewsReducer.updateReview;
export const selectReviewDetailsState = (store: RootState) => store.reviewsReducer.reviewDetails;
